export const environment = {
  production: false,
  name: 'development',
  baseUrl: 'https://api.dev.gestion.subcafaecp.com/api',
  reportesUrl: 'https://api.dev.reports.subcafaecp.com/api',
  appName: 'Subcafae Desarrollo',
};
